import NavItem from '@package/components/Navigation/Desktop/NavItem';

export default NavItem;
